var _path, _path2, _mask, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 21.75L2.25007 7.5L8.25007 3.75L15.7501 7.5L18.7501 5.625L21.7501 3.75V18L15.7501 21.75L8.25007 17.925L2.25 21.75Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.75V18",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.5C13.1642 10.5 13.5 10.1642 13.5 9.75C13.5 9.33579 13.1642 9 12.75 9C12.3358 9 12 9.33579 12 9.75C12 10.1642 12.3358 10.5 12.75 10.5Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.5C13.1642 10.5 13.5 10.1642 13.5 9.75C13.5 9.33579 13.1642 9 12.75 9C12.3358 9 12 9.33579 12 9.75C12 10.1642 12.3358 10.5 12.75 10.5Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75C12 9.33579 12.3358 9 12.75 9V12C13.9926 12 15 10.9926 15 9.75H12ZM12.75 9C13.1642 9 13.5 9.33579 13.5 9.75H10.5C10.5 10.9926 11.5074 12 12.75 12V9ZM13.5 9.75C13.5 10.1642 13.1642 10.5 12.75 10.5V7.5C11.5074 7.5 10.5 8.50736 10.5 9.75H13.5ZM12.75 10.5C12.3358 10.5 12 10.1642 12 9.75H15C15 8.50736 13.9926 7.5 12.75 7.5V10.5Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0,
    mask: "url(#path-3-inside-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5V21",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap24);
export default __webpack_public_path__ + "static/media/Map-24.bca79f66.svg";
export { ForwardRef as ReactComponent };